/* eslint-disable react-hooks/exhaustive-deps */
import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { MenuView } from '../../../types/MenuView';

const useHideIconsOnMobile = () => {
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isMobile = useSelector(select.device.isMobile);
  const menuView = useSelector(select.cms.getMenuView);
  const isCasino = useSelector(select.cms.getBrandId) === BrandTypes.STARS_CASINO;
  const options = { threshold: 0.1 };
  const [isScrolled, setIsScrolled] = useState(true);

  const shouldHandleScroll = useMemo(
    () => !isDesktopEmbedded && isMobile && isCasino && menuView === MenuView.iconsAndText,
    [isDesktopEmbedded, isMobile, isCasino, menuView]
  );

  useEffect(() => {
    const header = document.getElementById('CMSheader');

    if (!shouldHandleScroll || !header) return;

    const observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => setIsScrolled(entries[0].isIntersecting),
      options
    );
    observer.observe(header);

    return () => {
      observer.disconnect();
    };
  }, [shouldHandleScroll]);

  return isScrolled;
};

export default useHideIconsOnMobile;
